// SendMessageModal.jsx
import { Modal, Typography, Input } from 'antd';

const { Title } = Typography;
const { TextArea } = Input;

const SendMessageModal = ({
  visible,
  onClose,
  message,
  onMessageChange,
  onSend,
}) => {
  return (
    <Modal
      visible={visible}
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
    >
      <div style={{ padding: 24 }}>
        <Title level={4}>Send a Message</Title>
        <TextArea
          placeholder="Message"
          autoSize={{ minRows: 4 }}
          value={message}
          onChange={onMessageChange}
          style={{ marginTop: 16, marginBottom: 16 }}
        />
        <button className="spButton1 py-1 px-3 me-2" type="primary" onClick={onSend}>
          Send
        </button>
      </div>
    </Modal>
  );
};

export default SendMessageModal;
